import session, { initSession, login, logout } from "../ducks/session.js";
import { parseJWT } from "../../utils.js";

const sessionHandler = (store) => (next) => (action) => {
  let token = null;

  if (initSession.match(action)) {
    token = localStorage.getItem("token");
    const isValid = validateToken(token);

    if (isValid) store.dispatch(login.fulfilled(token));
    if (!isValid) localStorage.removeItem("token");
  } else if (login.fulfilled.match(action)) {
    token = action.payload;
    localStorage.setItem("token", token);
    const data = parseJWT(token).data;
    action.payload = {};
    action.payload.userID = data.id;
    action.payload.userName = data.name;
    action.payload.firstName = data.firstname;
    action.payload.lastName = data.lastname;
    action.payload.role = data.role;
  } else if (logout.match(action)) {
    localStorage.removeItem("token");
  }
  return next(action);
};

function validateToken(token) {
  let data = parseJWT(token);
  if (data === undefined) return false;

  // if (data.exp < Math.floor(Date.now() / 1000)) return false;

  return true;
}

export default sessionHandler;
